import React from 'react'
import { Alert, AlertIcon, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionBox = motion.div

interface ErrorStateProps {
  error: string
}

export default function ErrorState({ error }: ErrorStateProps) {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Alert status="error" borderRadius="xl" bg="red.50" borderColor="red.200" border="1px">
        <AlertIcon />
        <Text fontWeight="medium">{error}</Text>
      </Alert>
    </MotionBox>
  )
}
